import { MESSAGE_CHAR_LIMIT } from "./types";
import React, { useContext } from "react";
import { Box, Stack, TextAreaField } from "@origin-digital/ods-core";
import { MessageContext } from "./MessageContext";
import styled from "styled-components";
import MessageFileDropZone from "./MessageFileDropZone";
import SelectedAttachment from "./SelectedAttachment";

const WithDragEventsListener = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
`;

const MessageInput = () => {
  const { messageTabState, setMessageTabState } = useContext(MessageContext);
  const { selectedAttachments, showFileDropZone, showInputError, inputText } =
    messageTabState;
  const onDragEnter = () => {
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      showFileDropZone: true,
    }));
  };

  const onDragLeave = () => {
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      showFileDropZone: false,
    }));
  };

  const onChange = (value: string | undefined) => {
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      inputText: value,
      showInputError: false,
    }));
  };

  return (
    <>
      {/* Message input */}
      <WithDragEventsListener
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
      >
        {showFileDropZone ? (
          <MessageFileDropZone />
        ) : (
          <TextAreaField
            id="message-input"
            variant="outlined"
            label="Enter message or drop a file here"
            helperText={
              showInputError
                ? "Oops, you must type a message first."
                : "Anyone who has access to this request can view these messages."
            }
            value={inputText}
            maxLength={MESSAGE_CHAR_LIMIT}
            onChange={(e) => onChange(e.target.value)}
            error={showInputError}
            muiProps={{
              sx: {
                "& .MuiInputBase-root": {
                  padding: 0, // removes internal padding
                  alignItems: "stretch", // ensures textarea fills the root
                },
                "& .MuiInputBase-inputMultiline": {
                  resize: "vertical",
                  overflow: "auto",
                  minHeight: "44px",
                  boxSizing: "border-box", // ensures the textarea respects height/padding
                  padding: "12px 16px",
                },
              },
            }}
          />
        )}
      </WithDragEventsListener>
      {/* End Message input */}
      {/* Selected files */}
      <Box marginTop="large">
        <Stack space="small">
          {selectedAttachments.map((selected, index) => (
            <SelectedAttachment
              messageAttachment={selected}
              index={index.toString()}
              key={index}
            />
          ))}
        </Stack>
      </Box>
      {/* End Selected files */}
    </>
  );
};

export default MessageInput;
